import { COMMERCE_PAYMENT_TYPE_ID } from 'customer-data-objects/constants/ObjectTypeIds';
import apiClient from 'hub-http/clients/apiClient';
export const deletePayment = ({
  objectId
}) => {
  return apiClient.delete(`inbounddb-objects/v1/crm-objects/${COMMERCE_PAYMENT_TYPE_ID}/${objectId}`);
};